'use client';

import { View } from '@bytel/trilogy-react-ts';

export function BannerText({ bannerText }: Readonly<{ bannerText?: string | null }>) {
    if (!bannerText) {
        return null;
    }
    return <View className='sticker sticker-wrap byou has-background-secondary-20'>{bannerText}</View>;
}
